import { render, staticRenderFns } from "./create.vue?vue&type=template&id=b8e84f02&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=b8e84f02&prod&lang=css"
import style1 from "./create.vue?vue&type=style&index=1&id=b8e84f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e84f02",
  null
  
)

export default component.exports